import { render, staticRenderFns } from "./fitnessLearningCourses.vue?vue&type=template&id=469cdd19&scoped=true&"
import script from "./fitnessLearningCourses.vue?vue&type=script&lang=js&"
export * from "./fitnessLearningCourses.vue?vue&type=script&lang=js&"
import style0 from "./fitnessLearningCourses.vue?vue&type=style&index=0&id=469cdd19&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469cdd19",
  null
  
)

export default component.exports